<template>
    <div>
        <a-skeleton :loading="loading" active >
            <a-list item-layout="horizontal" size="small" :data-source="data">
                <tower-card slot="renderItem" slot-scope="item" :tower="item"></tower-card>
            </a-list>
            <a-pagination :current="Number($route.params.page)" :total="tower" 
                :defaultPageSize="20" @change="change" :hideOnSinglePage="true"
            />
        </a-skeleton>
    </div>
</template>

<script>
import TowerCard from '../components/MyTowerCard.vue'

import { mapState } from 'vuex'
import axios from '../../../plugins/axios'

const Memo = {};

export default {
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.load(to.params.page);
        });
    },
    async beforeRouteUpdate(to, from, next) {
        await this.load(to.params.page);
        next();
    },
    data: () => ({
        data: [],
        loading: false,
    }),
    computed: {
        ...mapState('$user', [ 'userid', 'tower' ]),
    },
    methods: {
        async load(key) {
            if (!Memo[key]) {
                this.loading = true;
                const { data } = await axios.get(`/backend/user/detail.php?id=${ this.userid }&type=tower&page=${ key }`);
                Memo[data.page] = data.tower;
                this.loading = false;
            }
            this.data = Memo[key];
        },
        change(page) {
            this.$router.push({ name: 'tower', params: { page } });
        },
    },
    components: {
        TowerCard
    }
}
</script>
